import { render } from "./BrandDrivers.vue?vue&type=template&id=281958cb"
import script from "./BrandDrivers.vue?vue&type=script&lang=js"
export * from "./BrandDrivers.vue?vue&type=script&lang=js"

import "./BrandDrivers.vue?vue&type=style&index=0&id=281958cb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__